import React from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./components/Login";
import Dashboard from "./components/Dashboard";
import StudentList from "./components/StudentList";
import Attendance from "./components/Attendance";
import Promotions from "./components/Promotions";
import StudentDetail from "./components/StudentDetail";
import Class from "./components/Class";
import StudentRoles from "./components/StudentRoles";
import DebtType from "./components/DebtType";
import RecordPayments from "./components/RecordPayments";
import CreateEvent from "./components/CreateEvent";
import RegisterStudents from "./components/RegisterStudents";
import PrivateRoute from "./PrivateRoute";
import EventDetails from './components/EventDetails';
import ForgotPassword from './components/ForgotPassword';
import ChangePassword from './components/ChangePassword';
import ImageMaintenance from './components/ImageMaintenance';
import PaymentHistory from './components/PaymentHistory';

function App() {
  return (
      <Router>
        <Routes>
          <Route path="/" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/change-password" element={<PrivateRoute><ChangePassword /></PrivateRoute>} />
          <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
          <Route path="/students" element={<PrivateRoute><StudentList /></PrivateRoute>} />
          <Route path="/students/new" element={<PrivateRoute><StudentDetail /></PrivateRoute>} />
          <Route path="/students/edit/:id" element={<PrivateRoute><StudentDetail /></PrivateRoute>} />
          <Route path="/attendance" element={<PrivateRoute><Attendance /></PrivateRoute>} />
          <Route path="/promotions" element={<PrivateRoute><Promotions /></PrivateRoute>} />
          <Route path="/classes" element={<PrivateRoute><Class /></PrivateRoute>} />
          <Route path="/student-roles" element={<PrivateRoute><StudentRoles /></PrivateRoute>} />
          <Route path="/debt-types" element={<PrivateRoute><DebtType /></PrivateRoute>} />
          <Route path="/record-payments" element={<PrivateRoute><RecordPayments /></PrivateRoute>} />
          <Route path="/create-event" element={<PrivateRoute><CreateEvent /></PrivateRoute>} />
          <Route path="/register-students" element={<PrivateRoute><RegisterStudents /></PrivateRoute>} />
          <Route path="/event-details" element={<PrivateRoute><EventDetails /></PrivateRoute>} />
          <Route path="/image-maintenance" element={<PrivateRoute><ImageMaintenance /></PrivateRoute>} />
          <Route path="/payment-history" element={<PrivateRoute><PaymentHistory /></PrivateRoute>} />
        </Routes>
      </Router>
  );
}

export default App;
